module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Put-on-a-Big-Show-640.10738691.jpg";